import logo from "../../../../public/projects/Neo/images/logo/logo.png"
import evergreen from "../../../../public/projects/Godrej/images/projects/ev.jpg"

export const developerNeo = {
  
  properties: [
    {
      name: "Neoliv Alibaug Mumbai",
      image: evergreen,
      price: "On Request",
      state:"Pune",
      developer:"Neo",
      projectlocation:"West Pune",
      location: "Pune",
      bed: "Villas",
      size: "2200-3200 sq.ft.",
      url: ``,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    }, 
  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "2018",
  },
  about: `In 2018, Mohit Malhotra and other professionals in the field established NeoLiv, a platform for real estate development and financing. Leading industry specialists, 360 ONE (formerly IIFL Wealth), India's top wealth management organization with over USD 50 billion, and the former MD and CEO of Godrej Properties support the business...

 `,
};

